import ClipboardJS from 'clipboard'

/**
 * 复制内容到剪切板
 * @param {*} text 复制的内容
 * @param {*} callback 复制之后回调
 */
const copyText = (text: string, callback: () => void): void => {

  const div = document.createElement('div')
  div.setAttribute('data-clipboard-text', text)
  div.setAttribute('id', 'clipboard-container')
  div.style.position = 'absolute'
  div.style.left = '-9999px'
  document.body.appendChild(div)

  const clipboard = new ClipboardJS('#clipboard-container')
  clipboard.on('success', () => {
    callback && callback()
  })

  div.click()
}

export default copyText
